import React from 'react';
import { StaffManagementSection } from '@/components/admin/StaffManagementSection';

interface StaffSectionProps {
  isDemo?: boolean;
}

export const StaffSection: React.FC<StaffSectionProps> = ({ 
  isDemo = false,
}) => {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold">​</h2>
        <p className="text-sm text-muted-foreground">​</p>
      </div>
      <StaffManagementSection isDemo={isDemo} />
    </div>
  );
};

export default StaffSection;
